import { createStore } from 'vuex'
import settings from '@/store/settings'
import auth from '@/store/auth'
import situation from '@/store/situation'


export default createStore({
	modules: {
		settings,
		auth,
		situation
	}
})